<template>
  <div id="baseapp">
    <router-view />
  </div>
</template>

<script>
import { isEmpty } from "@/utils/utils.js";
// import { loadLocalMessage } from "@/i18n.js";
export default {
  created() {
    // 用来区分生产环境和开发环境
    const isProduction = process.env.NODE_ENV === "production";
    if (isProduction) {
      let promiseList = [];
      let languageList = this.$store.state.config.languageList;
      let languageData = this.$store.state.config.languageData;
      if (isEmpty(languageList)) {
        promiseList.push(this.getLanguageList());
      }
      if (isEmpty(languageData)) {
        promiseList.push(this.getLanguageData());
      } else {
        languageData.forEach((item) => {
          this.$i18n.setLocaleMessage(item.i18n, item.data.base);
        });
      }
      if (!isEmpty(promiseList)) {
        Promise.all(promiseList);
      }
    }
  },
  methods: {
    getLanguageList() {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getConfigByName("systemI18n")
          .then((res) => {
            if (res.resultCode == 1001) {
              if (!isEmpty(res.data)) {
                this.languageList = res.data.value;
                this.$store.commit("config/initLanguageList", res.data.value);
              }
              resolve(res);
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getLanguageData() {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getLanguageList()
          .then((res) => {
            if (res.resultCode == 1001) {
              this.$store.commit("config/initLanguageData", res.data);
              if (!isEmpty(res.data)) {
                console.log(res.data);
                res.data.forEach((item) => {
                  this.$i18n.setLocaleMessage(item.i18n, item.data.base);
                  console.log(this.$i18n);
                });
              }
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
</script>
<style lang="scss">
#baseapp {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  height: 100vh;
}
</style>
